import styled from "@emotion/styled";
import React from "react";
import { formatPatientGender } from "../../../formatUtils";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppList, AppListItem } from "../../Generic/AppList";
import { If } from "../../Generic/If";
import { isDefined } from "../../Generic/IsDefined";
import VisitStaffingPreferencesBadges from "../../VisitStaffingPreferencesBadges";
import {
  Slide,
  SlideAppListContainer,
  SlideHeader,
  SlideProps,
  SlideStepLabel,
  SlideTitle,
} from "./Slide";

export const Slide2PatientInfo = (props: SlideProps) => {
  const { staffingPreferences2, patientLanguages, patientFirstName, patientAge, patientGender } =
    props.visit.publicVisitBroadcastDetails;

  const patientInformation = [
    patientFirstName,
    patientAge,
    patientGender !== null ? formatPatientGender(patientGender).toLowerCase() : null,
  ]
    .filter(isDefined)
    .join(", ");

  return (
    <Slide>
      <SlideHeader>
        <If condition={props.showSteps}>
          <SlideStepLabel {...props} />
        </If>
        <SlideTitle>{translate(STRINGS.PATIENT_INFO)}</SlideTitle>
      </SlideHeader>

      <SlideAppListContainer>
        <AppList>
          <AppListItem
            leading={translate(STRINGS.PATIENT) + ":"}
            title={<PatientInfoValues>{patientInformation}</PatientInfoValues>}
          />

          <If condition={patientLanguages.length > 0}>
            <AppListItem
              leading={translate(STRINGS.LANGUAGES) + ":"}
              title={<PatientInfoValues>{patientLanguages.join(", ")}</PatientInfoValues>}
            />
          </If>
        </AppList>
      </SlideAppListContainer>

      <StaffingPreferencesContainer>
        <VisitStaffingPreferencesBadges staffingPreferences={staffingPreferences2} />
      </StaffingPreferencesContainer>
    </Slide>
  );
};

const StaffingPreferencesContainer = styled.div`
  padding-top: 16px;
`;

const PatientInfoValues = styled.div`
  font-weight: 800;
`;
